import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'AllCompanies',
  //   description: 'description of AllCompanies',
  //   url: '/all-companies',
  // },
];

export default help;
